import { forceFindTagWithTagId, isChild } from '../collections';
import { checkAndRemoveRootFromTag } from '../../../helpers/paths';

/**
 * Checks if collection is nested and returns collection details
 * @param {Object} params
 * @param {Object} params.collections - collections object
 * @param {Object} params.search - search object
 * @param {string|string[]} params.activeCollectionID - active collection ID or array of IDs
 * @param {string} params.path - target collection path
 * @returns {Object} - { isMoveIntoNestedCollection, activeCollection }
 */

const checkNestedCollection = async ({ collections, activeCollectionID, path }) => {
  let isMoveIntoNestedCollection = false;
  let activeCollection = null;

  if (activeCollectionID) {
    let collectionIds = activeCollectionID;
    if (typeof activeCollectionID === 'string') {
      collectionIds = [activeCollectionID];
    }
    const foundCollections = await forceFindTagWithTagId({ collections: collections.collections, search: collections.search, collectionIds });
    const normalizedCollections = foundCollections.filter((collection) => !!collection);
    [activeCollection] = normalizedCollections;
    if (activeCollection) {
      const fullPathActiveCollection = activeCollection.path + activeCollection.name;
      isMoveIntoNestedCollection = isChild(fullPathActiveCollection, `/${checkAndRemoveRootFromTag(path)}`);
    }
  }
  return { isMoveIntoNestedCollection, activeCollection };
};

export default checkNestedCollection;
